(function () {
    'use strict';

    angular.module('asys')
        .controller('ReiterTarifmerkmaleController', ReiterTarifmerkmaleController);

    ReiterTarifmerkmaleController.$inject = [
        '$scope',
        '$log',
        '$timeout',
        'lodash',
        'moment',
        'AppConfig',
        'AngebotModel',
        'AngebotKfzService',
        'BasisAngebotService',
        'MiscUtilsService',
        'LoadingIndicatorService',
        'sfkSondereinstufungZweitwagenFlags',
        'angebotSpezifischeWerte',
        'NavigationService',
        'FormFieldUtilsService',
        'AdresseUtilsService'
    ];
    function ReiterTarifmerkmaleController($scope, $log, $timeout, _, moment, AppConfig, AngebotModel, AngebotKfzService, BasisAngebotService, MiscUtilsService, LoadingIndicatorService, sfkSondereinstufungZweitwagenFlags, angebotSpezifischeWerte, NavigationService, FormFieldUtilsService, AdresseUtilsService) {
        var vm = this,
            angebotVm = $scope.angebotVm,
            wkz = _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.wkz.wert'),
            wagniskennziffern = AppConfig.ANGEBOT.kfz.wkz,
            erlaubteTarifmerkmale = AngebotKfzService.getErlaubteTarifmerkmale(angebotVm.angebotModel.angebot),
            momentYearEndObj = {
                date: 31,
                month: 11
            };

        $log.debug('ReiterTarifmerkmaleController', vm);

        vm.onSubmit = onSubmit;
        vm.onFahrzeugFahrerNurVnChanged = onFahrzeugFahrerNurVnChanged;
        vm.onAntragstellerGeburtsdatumChanged = onAntragstellerGeburtsdatumChanged;
        vm.onJuengsterFahrerGeburtsdatumChanged = onJuengsterFahrerGeburtsdatumChanged;
        vm.onAeltesterFahrerGeburtsdatumChanged = onAeltesterFahrerGeburtsdatumChanged;
        vm.juengsterFahrerJuengsterFahrerHatFuehrerscheinMit17Changed = juengsterFahrerJuengsterFahrerHatFuehrerscheinMit17Changed;
        vm.setJuengsterFahrerGeburtsdatum = setJuengsterFahrerGeburtsdatum;
        vm.setAeltesterFahrerGeburtsdatum = setAeltesterFahrerGeburtsdatum;
        vm.onChangePostleitzahlFahrzeughalter = onChangePostleitzahlFahrzeughalter;
        vm.resetRabattschutz = resetRabattschutz;
        vm.setSfkKhKvSondereinstufungen = setSfkKhKvSondereinstufungen;
        vm.isSfkDisabled = isSfkDisabled;
        vm.validateJuengsterFahrerUndAntragstellerGeburtsdatum = validateJuengsterFahrerUndAntragstellerGeburtsdatum;
        vm.validateAeltesterFahrerUndAntragstellerGeburtsdatum = validateAeltesterFahrerUndAntragstellerGeburtsdatum;
        vm.isGeburtsdatumAntragstellerErlaubt = isGeburtsdatumAntragstellerErlaubt;
        vm.isJuengsterFahrerGeburtsdatumErlaubt = isJuengsterFahrerGeburtsdatumErlaubt;
        vm.isJuengsterFahrerHatFuehrerscheinMit17Erlaubt = isJuengsterFahrerHatFuehrerscheinMit17Erlaubt;
        vm.isAeltesterFahrerGeburtsdatumErlaubt = isAeltesterFahrerGeburtsdatumErlaubt;
        vm.isAeltesterFahrerHatFuehrerscheinMit17Erlaubt = isAeltesterFahrerHatFuehrerscheinMit17Erlaubt;
        vm.onVorversicherungAufDrittenChanged = onVorversicherungAufDrittenChanged;
        vm.isAbstellplatzErlaubt = isAbstellplatzErlaubt;
        vm.isWohneigentumErlaubt = isWohneigentumErlaubt;
        vm.isSondereinstufungZweitwagenErlaubt = isSondereinstufungZweitwagenErlaubt;
        vm.isSondereinstufungZweitwagenEditierbar = isSondereinstufungZweitwagenEditierbar;
        vm.isSondereinstufungMopedErlaubt = isSondereinstufungMopedErlaubt;
        vm.isSondereinstufungMopedEditierbar = isSondereinstufungMopedEditierbar;
        vm.isSondereinstufungYDErlaubt = isSondereinstufungYDErlaubt;
        vm.isSondereinstufungYDEditierbar = isSondereinstufungYDEditierbar;
        vm.isSondereinstufungDisabled = isSondereinstufungDisabled;
        vm.getSfkBezeichnung = getSfkBezeichnung;
        vm.getSondereinstufungZweitwagenFlags = getSondereinstufungZweitwagenFlags;
        vm.getMoeglicheSchadenfreiheitsklassen = getMoeglicheSchadenfreiheitsklassen;
        vm.onSfkHaftpflichtChanged = onSfkHaftpflichtChanged;
        vm.onSfkVollkaskoChanged = onSfkVollkaskoChanged;
        vm.onSfkBisherKeinVollkasko = onSfkBisherKeinVollkasko;
        vm.getLabelSfKlasseHaftpflicht = getLabelSfKlasseHaftpflicht;
        vm.isSfkVollkaskoSichtbar = isSfkVollkaskoSichtbar;
        vm.isSfkVollkaskoAngleichungKh = isSfkVollkaskoAngleichungKh;
        vm.isHinweisSfkVollkaskoSichtbar = isHinweisSfkVollkaskoSichtbar;
        vm.isHinweisSfkHaftpflichtSichtbar = isHinweisSfkHaftpflichtSichtbar;
        vm.isHinweisSfkHaftpflichtSf0Sichtbar = isHinweisSfkHaftpflichtSf0Sichtbar;
        vm.isHinweisSfkHaftpflichtSf0Und1Querstrich2Sichtbar = isHinweisSfkHaftpflichtSf0Und1Querstrich2Sichtbar;
        vm.isHinweisSfkHaftpflichtSfWaehlbarSichtbar = isHinweisSfkHaftpflichtSfWaehlbarSichtbar;
        vm.isSfkBisherKeinVollkaskoErlaubt = isSfkBisherKeinVollkaskoErlaubt;
        vm.isGevo = isGevo;
        vm.isGevoVorversicherungInternExternErlaubt = isGevoVorversicherungInternExternErlaubt;
        vm.onGevoVorversicherungInternExternChanged = onGevoVorversicherungInternExternChanged;
        vm.isWurdeVertragGekuendigtVomVuErlaubt = isWurdeVertragGekuendigtVomVuErlaubt;
        vm.isVorversicherungsdauerErlaubt = isVorversicherungsdauerErlaubt;
        vm.numberComparator = numberComparator;
        vm.onPostleitzahlAntragstellerChanged = onPostleitzahlAntragstellerChanged;
        vm.isHinweisVorversicherungSchadenverlaufErlaubt = isHinweisVorversicherungSchadenverlaufErlaubt;
        vm.isRabattuebertragungVorversicherungAufDrittenErlaubt = isRabattuebertragungVorversicherungAufDrittenErlaubt;
        vm.isBlockArbeitgeberBerufErlaubt = isBlockArbeitgeberBerufErlaubt;
        vm.isBlockFahrerkreisErlaubt = isBlockFahrerkreisErlaubt;

        activate();

        function activate() {
            vm.currentEvent = null;

            vm.showJuengsterFahrerAntragsteller = false;
            vm.showJuengsterFahrerSonstigePerson = false;
            vm.showAeltesterFahrerSonstigePerson = false;
            vm.CONSTANTS = {
                fahrerkreis: BasisAngebotService.getConstant('fahrerkreis', angebotVm.angebotModel.angebot)
            };
            if (MiscUtilsService.isNotEmpty(angebotSpezifischeWerte)) {
                angebotVm.schadenfreiheitsklassen = _.get(angebotSpezifischeWerte, 'schadenfreiheitsklassen');
                angebotVm.schadenfreiheitsklassenZuGevo = _.get(angebotSpezifischeWerte, 'schadenfreiheitsklassenZuGevo');
            }

            if (angebotVm.isPrivatPerson) {
                vm.labelPostleitzahlAntragsteller = 'Postleitzahl des Antragstellers';
            } else {
                vm.labelPostleitzahlAntragsteller = 'Postleitzahl der Firma';
            }

            vm.berechnenBtnText = BasisAngebotService.isAngebotAenderbar(angebotVm.angebotModel.angebot, 'ANGEBOT') ? 'Beitrag berechnen' : 'Beitrag anzeigen';
            vm.sfkSondereinstufungZweitwagenFlags = sfkSondereinstufungZweitwagenFlags;
            vm.schadenfreiheitsklassen = getMoeglicheSchadenfreiheitsklassen();
            vm.isPostleitzahlFahrzeughalterDisabled = !!(
                !BasisAngebotService.isAngebotAnonym(angebotVm.angebotModel.angebot) &&
                BasisAngebotService.getAngebotspartner(angebotVm.angebotModel.angebot, 'antragsteller').postleitzahl
            );

            if (_.size(_.get(vm.schadenfreiheitsklassen, 'haftpflicht')) === 1) {
                _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.haftpflicht', _.get(vm.schadenfreiheitsklassen, 'haftpflicht[0]'));
            }

            if (_.size(_.get(vm.schadenfreiheitsklassen, 'vollkasko')) === 1) {
                _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.vollkasko', _.get(vm.schadenfreiheitsklassen, 'vollkasko[0]'));
            }

            vm.tooltipFueherschein17FahrzeugBezeichnung = _.compact([
                wkz === wagniskennziffern.PKW ? 'Auto' : '',
                wkz === wagniskennziffern.CAMPINGKRAFTWAGEN_WOHNMOBILE ? 'Wohnmobile' : ''
            ]).join('');
            setMaxDatumJuengsterFahrer();
            setMaxDatumAeltesterFahrer();
            setPlaceholders();

            setJuengsterFahrerGeburtsdatum(false);
            setAeltesterFahrerGeburtsdatum(false);
            resetSchadenfreiheitsklassen();
            resetSondereinstufungen();
        }
        function onSubmit($event) {
            var nextStep = _.get($event, 'toState.name') || NavigationService.getNext().name;

            if (!vm.tarifForm.$valid || vm.pending) {
                $event && $event.preventDefault();
                return false;
            }

            LoadingIndicatorService.addInProgress();

            NavigationService.goToStep(nextStep, {
                formValidation: true,
                ignoreFollowingCheck: true
            });

            LoadingIndicatorService.removeInProgress();
        }
        function setPlaceholders() {
            vm.placeholders = {
                angebotsgegenstandFahrzeugJuengsterFahrerGeburtsdatum: {
                    max: [
                        moment(BasisAngebotService.getTarifauskunftsdatum(angebotVm.angebotModel.angebot)).set(momentYearEndObj).diff(vm.maxJuengsterFahrerGeburtsdatum, 'years')
                    ]
                },
                angebotsgegenstandFahrzeugAeltesterFahrerGeburtsdatum: {
                    max: [
                        moment(BasisAngebotService.getTarifauskunftsdatum(angebotVm.angebotModel.angebot)).set(momentYearEndObj).diff(vm.maxAeltesterFahrerGeburtsdatum, 'years')
                    ]
                },
                wurdeVertragGekuendigtVomVu: {
                    banned: [
                        angebotVm.isPrivatPerson ? AppConfig.APP.telefon : AppConfig.APP.telefonFirmenkunde,
                        angebotVm.isPrivatPerson ? '' : ' oder per E-Mail an kfz-firmen@wgv.de'
                    ]
                }
            };
        }

        function onFahrzeugFahrerNurVnChanged(fahrzeugFahrerNurVn) {
            if (erlaubteTarifmerkmale.fuehrerschein17JuengsterFahrer) {
                _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.juengsterFahrer.juengsterFahrerHatFuehrerscheinMit17', null);
            }

            if (erlaubteTarifmerkmale.fuehrerschein17AeltesterFahrer) {
                _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.aeltesterFahrer.aeltesterFahrerHatFuehrerscheinMit17', null);
            }
            setMaxDatumJuengsterFahrer();
            setMaxDatumAeltesterFahrer();

            setJuengsterFahrerGeburtsdatum();
            setAeltesterFahrerGeburtsdatum();
        }

        function onAntragstellerGeburtsdatumChanged(geburtsdatumAntragsteller) {
            if (geburtsdatumAntragsteller) {
                var alterAntragsteller = moment(BasisAngebotService.getTarifauskunftsdatum(angebotVm.angebotModel.angebot), AppConfig.API.dateFormat).year() - moment(geburtsdatumAntragsteller, AppConfig.API.dateFormat).year();

                if (alterAntragsteller >= 25) {
                    _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.juengsterFahrer.juengsterFahrerHatFuehrerscheinMit17', null);
                }
            }
            setJuengsterFahrerGeburtsdatum();
            setAeltesterFahrerGeburtsdatum();
            setMaxDatumJuengsterFahrer();
            setMaxDatumAeltesterFahrer();
            vm.schadenfreiheitsklassen = getMoeglicheSchadenfreiheitsklassen();
            vm.showJuengsterFahrerAntragsteller = true;

            $timeout(function () {
                vm.showJuengsterFahrerAntragsteller = false;
            }, 1000);
        }

        function onJuengsterFahrerGeburtsdatumChanged(geburtsdatumJuengsterFahrer) {
            if (geburtsdatumJuengsterFahrer) {
                var alterJuensgterFahrer = moment(BasisAngebotService.getTarifauskunftsdatum(angebotVm.angebotModel.angebot), AppConfig.API.dateFormat).year() - moment(geburtsdatumJuengsterFahrer, AppConfig.API.dateFormat).year();

                if (alterJuensgterFahrer >= 25) {
                    _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.juengsterFahrer.juengsterFahrerHatFuehrerscheinMit17', null);
                }
            }

            getSondereinstufungZweitwagenFlags();
            setMaxDatumAeltesterFahrer();
            vm.showJuengsterFahrerSonstigePerson = true;

            $timeout(function () {
                vm.showJuengsterFahrerSonstigePerson = false;
            }, 1000);
        }

        function onAeltesterFahrerGeburtsdatumChanged(geburtsdatumAeltesterFahrer) {
            if (geburtsdatumAeltesterFahrer) {
                var alterAeltesterFahrer = moment(BasisAngebotService.getTarifauskunftsdatum(angebotVm.angebotModel.angebot), AppConfig.API.dateFormat).year() - moment(geburtsdatumAeltesterFahrer, AppConfig.API.dateFormat).year();

                if (alterAeltesterFahrer >= 25) {
                    _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.aeltesterFahrer.aeltesterFahrerHatFuehrerscheinMit17', null);
                }
            }

            vm.showAeltesterFahrerSonstigePerson = true;

            $timeout(function () {
                vm.showAeltesterFahrerSonstigePerson = false;
            }, 1000);
        }
        function setMaxDatumJuengsterFahrer() {
            var tarifauskunftsdatum = BasisAngebotService.getTarifauskunftsdatum(angebotVm.angebotModel.angebot);

            if (_.includes([
                wagniskennziffern.LEICHTKRAFTROLLER_50_BIS_125_CCM, // 14
                wagniskennziffern.LEICHTKRAFTRAEDER_50_BIS_135_CCM // 24
            ], wkz)) {
                vm.maxJuengsterFahrerGeburtsdatum = moment(tarifauskunftsdatum).subtract(16, 'years').set(momentYearEndObj).format(AppConfig.API.dateFormat);
            } else {
                vm.maxJuengsterFahrerGeburtsdatum = _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.juengsterFahrer.juengsterFahrerHatFuehrerscheinMit17') ?
                    moment(tarifauskunftsdatum).subtract(17, 'years').set(momentYearEndObj).format(AppConfig.API.dateFormat) :
                    moment(tarifauskunftsdatum).subtract(18, 'years').set(momentYearEndObj).format(AppConfig.API.dateFormat);
            }
        }
        function setMaxDatumAeltesterFahrer() {
            var tarifauskunftsdatum = BasisAngebotService.getTarifauskunftsdatum(angebotVm.angebotModel.angebot),
                geburtsdatumJuengsterFahrer = _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.juengsterFahrer.geburtsdatum');

            if (_.includes([
                wagniskennziffern.LEICHTKRAFTROLLER_50_BIS_125_CCM, // 14
                wagniskennziffern.LEICHTKRAFTRAEDER_50_BIS_135_CCM // 24
            ], wkz)) {
                vm.maxAeltesterFahrerGeburtsdatum = moment(tarifauskunftsdatum).subtract(16, 'years').set(momentYearEndObj).format(AppConfig.API.dateFormat);
            } else {
                vm.maxAeltesterFahrerGeburtsdatum = _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.aeltesterFahrer.aeltesterFahrerHatFuehrerscheinMit17') ?
                    moment(tarifauskunftsdatum).subtract(17, 'years').set(momentYearEndObj).format(AppConfig.API.dateFormat) :
                    moment(tarifauskunftsdatum).subtract(18, 'years').set(momentYearEndObj).format(AppConfig.API.dateFormat);
            }

            vm.maxAeltesterFahrerGeburtsdatum = moment(geburtsdatumJuengsterFahrer, AppConfig.API.dateFormat).isBefore(moment(vm.maxAeltesterFahrerGeburtsdatum, AppConfig.API.dateFormat)) ? geburtsdatumJuengsterFahrer : vm.maxAeltesterFahrerGeburtsdatum;
        }
        function juengsterFahrerJuengsterFahrerHatFuehrerscheinMit17Changed(juengsterFahrerHatFuehrerscheinMit17, giltAuchFuerAeltestenFahrer) {
            if (giltAuchFuerAeltestenFahrer) {
                _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.aeltesterFahrer.aeltesterFahrerHatFuehrerscheinMit17', juengsterFahrerHatFuehrerscheinMit17);
            }

            setMaxDatumJuengsterFahrer();
            setPlaceholders();
        }
        function setJuengsterFahrerGeburtsdatum(resetJuengsterFahrerGeburtsdatum) {
            if (!isJuengsterFahrerGeburtsdatumErlaubt() || !BasisAngebotService.isAngebotAenderbar(angebotVm.angebotModel.angebot, 'ANGEBOT')) {
                return;
            }

            var geburtsdatumAntragsteller = BasisAngebotService.getAngebotspartner(angebotVm.angebotModel.angebot, 'antragsteller').geburtsdatum,
                geburtsdatumJuengsterFahrer = _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.juengsterFahrer.geburtsdatum'),
                fahrerkreisNurVn;

            if (!geburtsdatumAntragsteller) {
                return;
            }

            resetJuengsterFahrerGeburtsdatum = MiscUtilsService.isEmpty(resetJuengsterFahrerGeburtsdatum) ? true : resetJuengsterFahrerGeburtsdatum;
            fahrerkreisNurVn = _.get(angebotVm.angebotModel.formData, 'fahrzeugFahrerNurVn');

            if (fahrerkreisNurVn && (!geburtsdatumJuengsterFahrer || !MiscUtilsService.isEqual(geburtsdatumAntragsteller, geburtsdatumJuengsterFahrer))) {
                _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.juengsterFahrer.geburtsdatum', geburtsdatumAntragsteller);
            }

            if (!fahrerkreisNurVn && MiscUtilsService.isEqual(geburtsdatumAntragsteller, geburtsdatumJuengsterFahrer) && resetJuengsterFahrerGeburtsdatum) {
                _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.juengsterFahrer.geburtsdatum', null);
            }

            getSondereinstufungZweitwagenFlags();
        }
        function setAeltesterFahrerGeburtsdatum(resetAeltesterFahrerGeburtsdatum) {
            if (!isAeltesterFahrerGeburtsdatumErlaubt() || !BasisAngebotService.isAngebotAenderbar(angebotVm.angebotModel.angebot, 'ANGEBOT')) {
                return;
            }

            var geburtsdatumAntragsteller = BasisAngebotService.getAngebotspartner(angebotVm.angebotModel.angebot, 'antragsteller').geburtsdatum,
                geburtsdatumAeltesterFahrer = _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.aeltesterFahrer.geburtsdatum'),
                fahrerkreisNurVn;

            if (!geburtsdatumAntragsteller) {
                return;
            }

            resetAeltesterFahrerGeburtsdatum = MiscUtilsService.isEmpty(resetAeltesterFahrerGeburtsdatum) ? true : resetAeltesterFahrerGeburtsdatum;
            fahrerkreisNurVn = _.get(angebotVm.angebotModel.formData, 'fahrzeugFahrerNurVn');

            if (fahrerkreisNurVn && (!geburtsdatumAeltesterFahrer || !MiscUtilsService.isEqual(geburtsdatumAntragsteller, geburtsdatumAeltesterFahrer))) {
                _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.aeltesterFahrer.geburtsdatum', geburtsdatumAntragsteller);
            }

            if (!fahrerkreisNurVn && MiscUtilsService.isEqual(geburtsdatumAntragsteller, geburtsdatumAeltesterFahrer) && resetAeltesterFahrerGeburtsdatum) {
                _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.aeltesterFahrer.geburtsdatum', null);
            }
        }

        function onChangePostleitzahlFahrzeughalter(zulassungsbezirk) {
            zulassungsbezirk = zulassungsbezirk || {};

            if (MiscUtilsService.isEverythingNotEmpty(zulassungsbezirk.plz, zulassungsbezirk.ort) && _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.fahrzeughaltereigenschaft.wert') === _.get(BasisAngebotService.getConstant('fahrzeughaltereigenschaften', angebotVm.angebotModel.angebot), 'versicherungsnehmer.wert')) {
                if (BasisAngebotService.isAngebotAnonym(angebotVm.angebotModel.angebot)) {
                    var antragsteller = BasisAngebotService.getAngebotspartner(angebotVm.angebotModel.angebot, 'antragsteller');

                    antragsteller.postleitzahl = _.padStart(zulassungsbezirk.plz, 5, '0');
                    antragsteller.ort = zulassungsbezirk.ort;
                }
            }
        }

        function onVorversicherungAufDrittenChanged() {
            AngebotKfzService.ermittleGevoId(angebotVm.angebotModel);

            LoadingIndicatorService.addInProgress();
            FormFieldUtilsService.handlePending(vm.tarifForm, 'gevoWechsel', true);

            AngebotKfzService.korrigiereWerteNachGeVoWechsel(angebotVm.angebotModel.angebot, true);
            BasisAngebotService.refreshAngebot(angebotVm.angebotModel, {
                shouldRefreshVertragsdaten: AngebotKfzService.shouldUpdateVertragsdaten(angebotVm.angebotModel.angebot)
            }).then(function () {
                AngebotModel.angebotVorbelegen(AngebotModel.getLastSavedAngebotDefaults(), true);
                if (!angebotVm.tarifauskunftsdatumChangedManually && _.get(angebotVm.angebotModel.angebot, 'rahmenDaten.angebotsdatumVorbelegung')) {
                    BasisAngebotService.setTarifauskunftsdatum(angebotVm.angebotModel.angebot, _.get(angebotVm.angebotModel.angebot, 'rahmenDaten.angebotsdatumVorbelegung'));
                    _.set(angebotVm.angebotModel.angebot, 'allgemeineAntragsdaten.versicherungsbeginn', _.get(angebotVm.angebotModel.angebot, 'rahmenDaten.angebotsdatumVorbelegung'));
                }

                wkz = _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.wkz.wert');

                return AngebotKfzService.getSfkKhKv(angebotVm.angebotModel, true).then(function (data) {
                    angebotVm.schadenfreiheitsklassenZuGevo = {
                        haftpflicht: data.klassenHaftpflicht,
                        vollkasko: data.klassenVollkasko
                    };
                    BasisAngebotService.getGlobals(angebotVm.angebotModel).then(function (globals) {
                        _.merge(angebotVm, globals);
                        FormFieldUtilsService.handlePending(vm.tarifForm, 'gevoWechsel', false);
                    });
                }).catch(function () {
                    FormFieldUtilsService.handlePending(vm.tarifForm, 'gevoWechsel', false);
                });
            }).catch(function () {
                FormFieldUtilsService.handlePending(vm.tarifForm, 'gevoWechsel', false);
            }).finally(function () {
                LoadingIndicatorService.removeInProgress();
                vm.reInitTarifauskunftsdatum = false;
                erlaubteTarifmerkmale = AngebotKfzService.getErlaubteTarifmerkmale(angebotVm.angebotModel.angebot);
                vm.schadenfreiheitsklassen = getMoeglicheSchadenfreiheitsklassen();
                resetSchadenfreiheitsklassen();
                resetSondereinstufungen();
            });
        }
        function resetRabattschutz() {
            if (!!_.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.rabattschutz') && !AngebotKfzService.isRabattschutzErlaubt(angebotVm.angebotModel.angebot)) {
                _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.rabattschutz', false);
            }
        }
        function setSfkKhKvSondereinstufungen() {
            AngebotKfzService.setSfkKhKvSondereinstufungen(angebotVm.angebotModel);
            vm.schadenfreiheitsklassen = getMoeglicheSchadenfreiheitsklassen();
            resetSchadenfreiheitsklassen();
        }
        function isSfkDisabled(sfkType) {
            var schadenfreiheitsklassen = _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen', {});

            return (
                schadenfreiheitsklassen.zweitwagenUndPartnerregelung && _.size(AppConfig.ANGEBOT.kfz.sfKlasseSondereinstufungen.ZWEITWAGEN) === 1 ||
                schadenfreiheitsklassen.sondereinstufungMoped && _.size(AppConfig.ANGEBOT.kfz.sfKlasseSondereinstufungen.MOPED) === 1 ||
                schadenfreiheitsklassen.sondereinstufungYD && _.size(AppConfig.ANGEBOT.kfz.sfKlasseSondereinstufungen.YD) === 1 ||
                _.get(angebotVm, 'ersatzgeschaeftAenderbarMap.angebotsgegenstandFahrzeug.schadenfreiheitsklassen.' + sfkType) === false ||
                !erlaubteTarifmerkmale.sfKlassen ||
                _.size(_.get(vm.schadenfreiheitsklassen, sfkType)) === 1
            );
        }
        function validateJuengsterFahrerUndAntragstellerGeburtsdatum(value) {
            var fahrerkreisNurVn = _.get(angebotVm.angebotModel.formData, 'fahrzeugFahrerNurVn'),
                geburtsdatumAntragsteller = BasisAngebotService.getAngebotspartner(angebotVm.angebotModel.angebot, 'antragsteller').geburtsdatum,
                geburtsdatumJuengsterFahrer = value;

            if (!fahrerkreisNurVn || MiscUtilsService.isAtLeastOneEmpty(geburtsdatumAntragsteller, geburtsdatumJuengsterFahrer)) {
                return true;
            }

            return moment(geburtsdatumJuengsterFahrer, AppConfig.API.dateFormat).isSame(moment(geburtsdatumAntragsteller, AppConfig.API.dateFormat), 'year');
        }
        function validateAeltesterFahrerUndAntragstellerGeburtsdatum(value) {
            var fahrerkreisNurVn = _.get(angebotVm.angebotModel.formData, 'fahrzeugFahrerNurVn'),
                geburtsdatumAntragsteller = BasisAngebotService.getAngebotspartner(angebotVm.angebotModel.angebot, 'antragsteller').geburtsdatum,
                geburtsdatumAeltesterFahrer = value;

            if (!fahrerkreisNurVn || MiscUtilsService.isAtLeastOneEmpty(geburtsdatumAntragsteller, geburtsdatumAeltesterFahrer)) {
                return true;
            }

            return moment(geburtsdatumAeltesterFahrer, AppConfig.API.dateFormat).isSame(moment(geburtsdatumAntragsteller, AppConfig.API.dateFormat), 'year');
        }
        function isGeburtsdatumAntragstellerErlaubt() {
            return AngebotKfzService.isGeburtsdatumAntragstellerErlaubt(angebotVm.angebotModel.angebot);
        }
        function isJuengsterFahrerGeburtsdatumErlaubt() {
            return AngebotKfzService.isJuengsterFahrerGeburtsdatumErlaubt(angebotVm.angebotModel.angebot);
        }
        function isJuengsterFahrerHatFuehrerscheinMit17Erlaubt(geburtsdatum) {
            var alter = moment(BasisAngebotService.getTarifauskunftsdatum(angebotVm.angebotModel.angebot), AppConfig.API.dateFormat).year() - moment(geburtsdatum, AppConfig.API.dateFormat).year();

            return (
                erlaubteTarifmerkmale.fuehrerschein17JuengsterFahrer &&
                alter < 25
            );
        }
        function isAeltesterFahrerGeburtsdatumErlaubt() {
            return AngebotKfzService.isAeltesterFahrerGeburtsdatumErlaubt(angebotVm.angebotModel.angebot);
        }
        function isAeltesterFahrerHatFuehrerscheinMit17Erlaubt(geburtsdatum) {
            var alter = moment(BasisAngebotService.getTarifauskunftsdatum(angebotVm.angebotModel.angebot), AppConfig.API.dateFormat).year() - moment(geburtsdatum, AppConfig.API.dateFormat).year();

            return (
                erlaubteTarifmerkmale.fuehrerschein17AeltesterFahrer &&
                alter < 25
            );
        }
        function isAbstellplatzErlaubt() {
            return erlaubteTarifmerkmale.abstellplatz;
        }
        function isWohneigentumErlaubt() {
            return (
                angebotVm.isPrivatPerson &&
                erlaubteTarifmerkmale.wohneigentum
            );
        }
        function isSondereinstufungZweitwagenErlaubt() {
            return (
                _.get(vm.sfkSondereinstufungZweitwagenFlags, 'zweitwagenregelungSichtbar') &&
                !isGevo('KFZ_TARIFUMSTELLUNG')  // ist eigentlich nur bei GeVo 2 erlaubt (wird aber bereits über ICIS+ abgefangen - bei GeVo 5 kann es nie sein)
            );
        }
        function isSondereinstufungZweitwagenEditierbar() {
            return _.get(vm.sfkSondereinstufungZweitwagenFlags, 'zweitwagenregelungEditierbar');
        }
        function isSondereinstufungMopedErlaubt() {
            return (
                erlaubteTarifmerkmale.sondereinstufungMoped &&
                !isGevo('KFZ_TARIFUMSTELLUNG') // ist eigentlich nur bei GeVo 1 erlaubt (wird aber bereits über ICIS+ abgefangen - bei GeVo 5 kann es nie sein)
            );
        }
        function isSondereinstufungMopedEditierbar() {
            return (
                isSondereinstufungMopedErlaubt() &&
                !isGevo('KFZ_TARIFUMSTELLUNG') // ist eigentlich nur bei GeVo 1 erlaubt (wird aber bereits über ICIS+ abgefangen - bei GeVo 5 kann es nie sein)
            );
        }
        function isSondereinstufungYDErlaubt() {
            return (
                erlaubteTarifmerkmale.sondereinstufungYD &&
                !isGevo('KFZ_TARIFUMSTELLUNG') // ist eigentlich nur bei GeVo 1 erlaubt (wird aber bereits über ICIS+ abgefangen - bei GeVo 5 kann es nie sein)
            );
        }
        function isSondereinstufungYDEditierbar() {
            return (
                isSondereinstufungYDErlaubt() &&
                !isGevo('KFZ_TARIFUMSTELLUNG') // ist eigentlich nur bei GeVo 1 erlaubt (wird aber bereits über ICIS+ abgefangen - bei GeVo 5 kann es nie sein)
            );
        }
        function isSondereinstufungDisabled(sondereinstufung) {
            var disabled = false;

            if (sondereinstufung === 'moped') {
                disabled = (
                    _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.zweitwagenUndPartnerregelung') ||
                    _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.sondereinstufungYD') ||
                    !isSondereinstufungMopedEditierbar()
                );
            } else if (sondereinstufung === 'zweitwagen') {
                disabled = (
                    _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.sondereinstufungMoped') ||
                    _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.sondereinstufungYD') ||
                    !isSondereinstufungZweitwagenEditierbar()
                );
            } else if (sondereinstufung === 'yd') {
                disabled = (
                    _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.zweitwagenUndPartnerregelung') ||
                    _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.sondereinstufungMoped') ||
                    !isSondereinstufungYDEditierbar()
                );
            }

            return disabled;
        }
        function getSfkBezeichnung(sfklasse) {
            return AngebotKfzService.getSfkBezeichnung(sfklasse);
        }
        function getSondereinstufungZweitwagenFlags() {
            var isSubmit = FormFieldUtilsService.isSubmitEvent(vm.currentEvent);
            if (!_.get(vm.sfkSondereinstufungZweitwagenFlags, 'zweitwagenregelungSichtbar') ||
                !isJuengsterFahrerGeburtsdatumErlaubt() ||
                !_.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.juengsterFahrer.geburtsdatum')
            ) {
                resetSondereinstufungen();
                resetSchadenfreiheitsklassen();
                return;
            }

            if (_.get(vm.sfkSondereinstufungZweitwagenFlags, 'zweitwagenregelungSichtbar') && isJuengsterFahrerGeburtsdatumErlaubt()) {
                vm.pending = true;
                LoadingIndicatorService.addInProgress();

                AngebotKfzService.getSfkSondereinstufungZweitwagenFlags(angebotVm.angebotModel).then(function (sfkSondereinstufungZweitwagenFlags) {
                    vm.sfkSondereinstufungZweitwagenFlags = sfkSondereinstufungZweitwagenFlags;

                    resetSondereinstufungen();
                    vm.schadenfreiheitsklassen = getMoeglicheSchadenfreiheitsklassen();
                }).finally(function () {
                    LoadingIndicatorService.removeInProgress();
                    resetSchadenfreiheitsklassen();

                    vm.pending = false;
                    if (isSubmit) {
                        $timeout(function () {
                            FormFieldUtilsService.validate(vm.tarifForm, '$$controls', {
                                setTouched: true,
                                setIsSubmitted: true
                            });
                            onSubmit(vm.currentEvent);
                            vm.currentEvent = null;
                        });
                    }
                });
            } else {
                vm.schadenfreiheitsklassen = getMoeglicheSchadenfreiheitsklassen();
                resetSchadenfreiheitsklassen();
            }
        }
        function resetSondereinstufungen() {
            var zweitwagenUndPartnerregelung = _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.zweitwagenUndPartnerregelung'),
                sondereinstufungMoped = _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.sondereinstufungMoped'),
                sondereinstufungYD = _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.sondereinstufungYD'),
                isSfkSondereinstufungZweitwagenVorhanden = _.includes(AppConfig.ANGEBOT.kfz.sfKlasseSondereinstufungen.ZWEITWAGEN, _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.haftpflicht.klasse')),
                isSfkSondereinstufungMopedVorhanden = _.includes(AppConfig.ANGEBOT.kfz.sfKlasseSondereinstufungen.MOPED, _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.haftpflicht.klasse')),
                isSfkSondereinstufunYDVorhanden = _.includes(AppConfig.ANGEBOT.kfz.sfKlasseSondereinstufungen.YD, _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.haftpflicht.klasse'));

            if (zweitwagenUndPartnerregelung && (!isSondereinstufungZweitwagenErlaubt() || !isSondereinstufungZweitwagenEditierbar())) {
                _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.zweitwagenUndPartnerregelung', false);

                if (isSfkSondereinstufungZweitwagenVorhanden) {
                    _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.haftpflicht', null);
                    _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.vollkasko', null);
                }
            }

            if (sondereinstufungMoped && !isSondereinstufungMopedErlaubt()) {
                _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.sondereinstufungMoped', false);

                if (isSfkSondereinstufungMopedVorhanden) {
                    _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.haftpflicht', null);
                    _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.vollkasko', null);
                }
            }

            if (sondereinstufungYD && !isSondereinstufungYDErlaubt()) {
                _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.sondereinstufungYD', false);

                if (isSfkSondereinstufunYDVorhanden) {
                    _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.haftpflicht', null);
                    _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.vollkasko', null);
                }
            }
        }
        function getMoeglicheSchadenfreiheitsklassen() {
            var schadenfreiheitsklassenZuGevo = _.get(angebotVm, 'schadenfreiheitsklassenZuGevo', {}),
                schadenfreiheitsklassen = {
                    haftpflicht: schadenfreiheitsklassenZuGevo.haftpflicht,
                    vollkasko: schadenfreiheitsklassenZuGevo.vollkasko
                },
                sfKlasseSondereinstufungen = AppConfig.ANGEBOT.kfz.sfKlasseSondereinstufungen,
                schadenfreiheitsklassenAusgewaehlt = _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen') || {},
                sondereinstufung = false,
                maxGrundjahrSchadenfreiheitsklasse,
                alterAntragsteller,
                sizeSfkHaftpflichtListe,
                sizeSfkVollkaskoListe;
            if (_.get(vm.sfkSondereinstufungZweitwagenFlags, 'zweitwagenregelungEditierbar')) {
                if (_.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.zweitwagenUndPartnerregelung')) {
                    schadenfreiheitsklassen.haftpflicht = _.filter(_.get(angebotVm, 'schadenfreiheitsklassen.haftpflicht'), function (sfk) {
                        return _.includes(sfKlasseSondereinstufungen.ZWEITWAGEN, sfk.klasse);
                    });

                    schadenfreiheitsklassen.vollkasko = _.filter(_.get(angebotVm, 'schadenfreiheitsklassen.vollkasko'), function (sfk) {
                        return _.includes(sfKlasseSondereinstufungen.ZWEITWAGEN, sfk.klasse);
                    });

                    sondereinstufung = true;
                }
            }
            if (erlaubteTarifmerkmale.sondereinstufungMoped) {
                if (_.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.sondereinstufungMoped')) {
                    schadenfreiheitsklassen.haftpflicht = _.filter(_.get(angebotVm, 'schadenfreiheitsklassen.haftpflicht'), function (sfk) {
                        return _.includes(sfKlasseSondereinstufungen.MOPED, sfk.klasse);
                    });

                    schadenfreiheitsklassen.vollkasko = _.filter(_.get(angebotVm, 'schadenfreiheitsklassen.vollkasko'), function (sfk) {
                        return _.includes(sfKlasseSondereinstufungen.MOPED, sfk.klasse);
                    });

                    sondereinstufung = true;
                }
            }
            if (erlaubteTarifmerkmale.sondereinstufungYD) {
                if (_.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.sondereinstufungYD')) {
                    schadenfreiheitsklassen.haftpflicht = _.filter(_.get(angebotVm, 'schadenfreiheitsklassen.haftpflicht'), function (sfk) {
                        return _.includes(sfKlasseSondereinstufungen.YD, sfk.klasse);
                    });

                    schadenfreiheitsklassen.vollkasko = _.filter(_.get(angebotVm, 'schadenfreiheitsklassen.vollkasko'), function (sfk) {
                        return _.includes(sfKlasseSondereinstufungen.YD, sfk.klasse);
                    });

                    sondereinstufung = true;
                }
            }
            if (
                (
                    isGevo('KFZ_TRANSFERBESTIMMUNG_28') || // 1b
                    isGevo('KFZ_VERSICHERERWECHSEL_SELBES_FZG') || // 3
                    isGevo('KFZ_FAHRZEUGWECHSEL') || // 4
                    isGevo('KFZ_VERSICHERERWECHSEL_NEUES_FZG') // 4b
                ) &&
                BasisAngebotService.getAngebotspartner(angebotVm.angebotModel.angebot, 'antragsteller').geburtsdatum
            ) {
                alterAntragsteller = moment(BasisAngebotService.getTarifauskunftsdatum(angebotVm.angebotModel.angebot), AppConfig.API.dateFormat).year() - moment(BasisAngebotService.getAngebotspartner(angebotVm.angebotModel.angebot, 'antragsteller').geburtsdatum, AppConfig.API.dateFormat).year();
                sizeSfkHaftpflichtListe = _.size(schadenfreiheitsklassen.haftpflicht);
                sizeSfkVollkaskoListe = _.size(schadenfreiheitsklassen.vollkasko);

                if (alterAntragsteller) {
                    maxGrundjahrSchadenfreiheitsklasse = alterAntragsteller - 17;

                    if (maxGrundjahrSchadenfreiheitsklasse >= 0) {
                        if (!vm.showAlleSfkHaftpflichtEintraege) {
                            schadenfreiheitsklassen.haftpflicht = _.filter(_.get(angebotVm, 'schadenfreiheitsklassen.haftpflicht'), function (sfk) {
                                return parseInt(sfk.grundjahr, 10) <= maxGrundjahrSchadenfreiheitsklasse;
                            });

                            if (sizeSfkHaftpflichtListe !== _.size(schadenfreiheitsklassen.haftpflicht)) {
                                schadenfreiheitsklassen.haftpflicht.push({
                                    grundjahr: '-1',
                                    id: {
                                        id: '-1'
                                    },
                                    klasse: '-1',
                                    text: '- Weitere SF-Klassen anzeigen -'
                                });
                            }
                        }

                        if (!vm.showAlleSfkVollkaskoEintraege) {
                            schadenfreiheitsklassen.vollkasko = _.filter(_.get(angebotVm, 'schadenfreiheitsklassen.vollkasko'), function (sfk) {
                                return parseInt(sfk.grundjahr, 10) <= maxGrundjahrSchadenfreiheitsklasse;
                            });

                            if (sizeSfkVollkaskoListe !== _.size(schadenfreiheitsklassen.vollkasko)) {
                                schadenfreiheitsklassen.vollkasko.push({
                                    grundjahr: '-1',
                                    id: {
                                        id: '-1'
                                    },
                                    klasse: '-1',
                                    text: '- Weitere SF-Klassen anzeigen -'
                                });
                            }
                        }
                    }
                }
            }
            ['haftpflicht', 'vollkasko'].forEach(function (sfkType) {
                schadenfreiheitsklassen[sfkType] = _.uniqBy(schadenfreiheitsklassen[sfkType], 'klasse');

                if (
                    schadenfreiheitsklassenAusgewaehlt[sfkType] &&
                    MiscUtilsService.isNotEmpty(_.get(schadenfreiheitsklassenAusgewaehlt[sfkType], 'id.id')) &&
                    _.findIndex(schadenfreiheitsklassenZuGevo[sfkType], ['id.id', _.get(schadenfreiheitsklassenAusgewaehlt[sfkType], 'id.id')]) !== -1 &&
                    !sondereinstufung
                ) {
                    var sfkAusgewaehlt = schadenfreiheitsklassenAusgewaehlt[sfkType] || {},
                        idx;

                    idx = _.findIndex(schadenfreiheitsklassen[sfkType], ['klasse', sfkAusgewaehlt.klasse]);

                    _.remove(schadenfreiheitsklassen[sfkType], ['klasse', sfkAusgewaehlt.klasse]);
                    schadenfreiheitsklassen[sfkType].splice(idx, 0, sfkAusgewaehlt);
                }
            });

            return schadenfreiheitsklassen;
        }
        function resetSchadenfreiheitsklassen() {
            if (isGevo('KFZ_TARIFUMSTELLUNG') || !BasisAngebotService.isAngebotAenderbar(angebotVm.angebotModel.angebot, 'ANGEBOT')) {
                return;
            }

            var moeglicheSchadenfreiheitsklassen = vm.schadenfreiheitsklassen || {},
                schadenfreiheitsklassenAngebot = _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen'),
                schadenfreiheitsklassenAngebotHaftpflichtId = _.get(schadenfreiheitsklassenAngebot, 'haftpflicht.id.id'),
                schadenfreiheitsklassenAngebotVollkaskoId = _.get(schadenfreiheitsklassenAngebot, 'vollkasko.id.id');

            if (MiscUtilsService.isNotEmpty(schadenfreiheitsklassenAngebotHaftpflichtId)) {
                if (!_.find(moeglicheSchadenfreiheitsklassen.haftpflicht, ['id.id', schadenfreiheitsklassenAngebotHaftpflichtId])) {
                    _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.haftpflicht', null);
                }
            }

            if (MiscUtilsService.isNotEmpty(schadenfreiheitsklassenAngebotVollkaskoId)) {
                if (!_.find(moeglicheSchadenfreiheitsklassen.vollkasko, ['id.id', schadenfreiheitsklassenAngebotVollkaskoId])) {
                    _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.vollkasko', null);
                }
            }

            if (_.size(moeglicheSchadenfreiheitsklassen.haftpflicht) === 1 && isSfkDisabled('haftpflicht')) {
                _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.haftpflicht', moeglicheSchadenfreiheitsklassen.haftpflicht[0]);
            }

            if (_.size(moeglicheSchadenfreiheitsklassen.vollkasko) === 1 && isSfkDisabled('vollkasko')) {
                _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.vollkasko', moeglicheSchadenfreiheitsklassen.vollkasko[0]);
            }
        }

        function onSfkHaftpflichtChanged(sfkHaftpflicht) {
            sfkHaftpflicht = sfkHaftpflicht || {};

            if (sfkHaftpflicht.klasse === '-1') {
                vm.showAlleSfkHaftpflichtEintraege = true;
                _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.haftpflicht', null);
                vm.schadenfreiheitsklassen = getMoeglicheSchadenfreiheitsklassen();
            } else {
                if (
                    (
                        isGevo('KFZ_NEUGESCHAEFT') || // 1
                        isGevo('KFZ_ZUSAETZLICHER_VERTRAG') // 2
                    ) || (
                        (
                            isGevo('KFZ_TRANSFERBESTIMMUNG_28') || // 1b
                            isGevo('KFZ_VERSICHERERWECHSEL_SELBES_FZG') || // 3
                            isGevo('KFZ_FAHRZEUGWECHSEL') || // 4
                            isGevo('KFZ_VERSICHERERWECHSEL_NEUES_FZG') // 4b
                        ) && _.get(angebotVm.angebotModel.formData, 'sfkBisherKeinVollkasko') === true
                    )
                ) {
                    if (isSfkVollkaskoAngleichungKh()) {
                        _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.vollkasko', sfkHaftpflicht);
                    }
                }
            }

            resetRabattschutz();
        }

        function onSfkVollkaskoChanged(sfkVollkasko) {
            sfkVollkasko = sfkVollkasko || {};

            if (sfkVollkasko.klasse === '-1') {
                vm.showAlleSfkVollkaskoEintraege = true;
                _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.vollkasko', null);
                vm.schadenfreiheitsklassen = getMoeglicheSchadenfreiheitsklassen();
            }

            resetRabattschutz();
        }

        function onSfkBisherKeinVollkasko(value) {
            if (!value) {
                _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.vollkasko', null);
            } else {
                if (isSfkVollkaskoAngleichungKh()) {
                    _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.vollkasko', _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.haftpflicht'));
                } else {
                    _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.vollkasko', _.find(_.get(angebotVm.schadenfreiheitsklassenZuGevo, 'vollkasko'), ['klasse', '0']));
                }
            }
        }

        function getLabelSfKlasseHaftpflicht() {
            if (
                (
                    (
                        isGevo('KFZ_NEUGESCHAEFT') || // 1
                        isGevo('KFZ_ZUSAETZLICHER_VERTRAG') // 2
                    ) &&
                    !isSfkVollkaskoSichtbar()
                ) || !erlaubteTarifmerkmale.sfKlassen
             ) { // 1 oder 2
                return 'SF-Klasse Haftpflicht und Vollkasko';
            }

            return 'SF-Klasse Haftpflicht';
        }

        function isSfkVollkaskoSichtbar() {
            return (
                erlaubteTarifmerkmale.sfKlassen &&
                (
                    isGevo('KFZ_TARIFUMSTELLUNG') || // 5
                    (
                        (
                            isGevo('KFZ_TRANSFERBESTIMMUNG_28') || // 1b
                            isGevo('KFZ_VERSICHERERWECHSEL_SELBES_FZG') || // 3
                            isGevo('KFZ_FAHRZEUGWECHSEL') || // 4
                            isGevo('KFZ_VERSICHERERWECHSEL_NEUES_FZG') // 4b
                        ) &&
                        !_.get(angebotVm.angebotModel.formData, 'sfkBisherKeinVollkasko')
                    ) || (
                        (
                            _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.haftpflicht.klasse') !== '-1' &&
                            _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.haftpflicht.id.id') !== _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.vollkasko.id.id') &&
                            isSfkVollkaskoAngleichungKh()
                        )
                    )
                )
            );
        }

        function isSfkVollkaskoAngleichungKh() {
            return (
                _.includes([
                    wagniskennziffern.PKW,
                    wagniskennziffern.MOTORRAD,
                    wagniskennziffern.CAMPINGKRAFTWAGEN_WOHNMOBILE
                ], wkz)
            );
        }
        function isHinweisSfkHaftpflichtSichtbar() {
            if (isSondereinstufungMopedErlaubt() && _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.sondereinstufungMoped') === true) {
                return false;
            }

            if (isSondereinstufungYDErlaubt() && _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.sondereinstufungYD') === true) {
                return false;
            }

            if (isSondereinstufungZweitwagenEditierbar() && _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.zweitwagenUndPartnerregelung') === true) {
                return false;
            }

            return (
                isHinweisSfkHaftpflichtSf0Sichtbar() ||
                isHinweisSfkHaftpflichtSf0Und1Querstrich2Sichtbar() ||
                isHinweisSfkHaftpflichtSfWaehlbarSichtbar()
            );
        }

        function isHinweisSfkHaftpflichtSf0Sichtbar() {
            return (
                (
                    isGevo(['KFZ_NEUGESCHAEFT', 'KFZ_ZUSAETZLICHER_VERTRAG']) && // Gevo 1, 2
                    !_.includes([
                        wagniskennziffern.PKW, // 112
                        wagniskennziffern.MOTORRAD, // 3
                        wagniskennziffern.CAMPINGKRAFTWAGEN_WOHNMOBILE // 127
                    ], wkz)
                ) || (
                    isGevo(['KFZ_TRANSFERBESTIMMUNG_28', 'KFZ_VERSICHERERWECHSEL_SELBES_FZG', 'KFZ_FAHRZEUGWECHSEL', 'KFZ_VERSICHERERWECHSEL_NEUES_FZG']) && // Gevo 1b, 3, 4, 4b
                    _.includes([
                        wagniskennziffern.ANHAENGER_WERKNAH_UND_PRIVATVERKEHR, // 501
                        wagniskennziffern.WOHNWAGENANHAENGER // 541
                    ], wkz)
                )
            );
        }

        function isHinweisSfkHaftpflichtSf0Und1Querstrich2Sichtbar() {
            return (
                isGevo(['KFZ_NEUGESCHAEFT', 'KFZ_ZUSAETZLICHER_VERTRAG']) && // Gevo 1, 2
                _.includes([
                    wagniskennziffern.PKW,
                    wagniskennziffern.MOTORRAD,
                    wagniskennziffern.CAMPINGKRAFTWAGEN_WOHNMOBILE
                ], wkz)
            );
        }

        function isHinweisSfkHaftpflichtSfWaehlbarSichtbar() {
            return (
                isGevo(['KFZ_TRANSFERBESTIMMUNG_28', 'KFZ_VERSICHERERWECHSEL_SELBES_FZG', 'KFZ_FAHRZEUGWECHSEL', 'KFZ_VERSICHERERWECHSEL_NEUES_FZG']) && // Gevo 1b, 3, 4, 4b
                !_.includes([
                    wagniskennziffern.ANHAENGER_WERKNAH_UND_PRIVATVERKEHR, // 501
                    wagniskennziffern.WOHNWAGENANHAENGER // 541
                ], wkz)
            );
        }

        function isSfkBisherKeinVollkaskoErlaubt() {
            return (
                isGevo(['KFZ_TRANSFERBESTIMMUNG_28', 'KFZ_VERSICHERERWECHSEL_SELBES_FZG', 'KFZ_FAHRZEUGWECHSEL', 'KFZ_VERSICHERERWECHSEL_NEUES_FZG']) && // Gevo 1b, 3, 4, 4b
                erlaubteTarifmerkmale.sfKlassen
            );
        }
        function isHinweisSfkVollkaskoSichtbar() {
            return (
                !isSfkDisabled('vollkasko') &&
                isGevo(['KFZ_TRANSFERBESTIMMUNG_28', 'KFZ_VERSICHERERWECHSEL_SELBES_FZG', 'KFZ_FAHRZEUGWECHSEL', 'KFZ_VERSICHERERWECHSEL_NEUES_FZG']) && // Gevo 1b, 3, 4, 4b
                !_.includes([
                    wagniskennziffern.ANHAENGER_WERKNAH_UND_PRIVATVERKEHR, // 501
                    wagniskennziffern.WOHNWAGENANHAENGER // 541
                ], wkz)
            );
        }
        function isGevo(gevo) {
            return AngebotKfzService.isGevo(angebotVm.angebotModel.angebot, gevo);
        }

        function isGevoVorversicherungInternExternErlaubt() {
            return isGevo(['KFZ_FAHRZEUGWECHSEL', 'KFZ_VERSICHERERWECHSEL_NEUES_FZG']); // Gevo 4, 4b
        }

        function onGevoVorversicherungInternExternChanged(value) {
            if (value) {
                _.set(angebotVm.angebotModel.angebot, 'vorversicherung.wurdeVertragGekuendigtVomVu', null);
                _.set(angebotVm.angebotModel.angebot, 'vorversicherung.vorversicherungsdauer', null);
            }
            AngebotKfzService.ermittleGevoId(angebotVm.angebotModel);

            if (BasisAngebotService.isAngebotAenderbar(angebotVm.angebotModel.angebot, 'ANGEBOT')) {
                LoadingIndicatorService.addInProgress();
                BasisAngebotService.refreshAngebot(angebotVm.angebotModel, {
                    shouldRefreshVertragsdaten: AngebotKfzService.shouldUpdateVertragsdaten(angebotVm.angebotModel)
                }).finally(function () {
                    LoadingIndicatorService.removeInProgress();
                });
            }
        }
        function isWurdeVertragGekuendigtVomVuErlaubt() {
            return isGevo(['KFZ_VERSICHERERWECHSEL_SELBES_FZG', 'KFZ_VERSICHERERWECHSEL_NEUES_FZG']);
        }
        function isVorversicherungsdauerErlaubt() {
            return (
                AngebotKfzService.isGevo(angebotVm.angebotModel.angebot, ['KFZ_VERSICHERERWECHSEL_SELBES_FZG', 'KFZ_VERSICHERERWECHSEL_NEUES_FZG']) && // 3, 4b
                AngebotKfzService.isVorversicherungsdauerErlaubt(angebotVm.angebotModel.angebot)
            );
        }
        function numberComparator(value1, value2) {
            return MiscUtilsService.numberComparator(value1, value2);
        }
        function onPostleitzahlAntragstellerChanged(postleitzahl) {
            if (angebotVm.adressenAntragsteller && postleitzahl) {
                var adresse = AdresseUtilsService.getAdresseByPostleitzahl(angebotVm.adressenAntragsteller, postleitzahl, {
                    prioritaet: 'HAUPTADRESSE' // Hauptadressen bevorzugen
                });

                if (adresse) {
                    _.merge(_.get(angebotVm.angebotModel.angebot, 'antragsteller', {}), adresse);
                }

                angebotVm.adressAuswahlFilterAntragsteller = {
                    postleitzahl: postleitzahl
                };
            }

            NavigationService.setFollowingDisabled(true);
        }
        function isHinweisVorversicherungSchadenverlaufErlaubt() {
            return AngebotKfzService.isGevo(angebotVm.angebotModel.angebot, [
                'KFZ_TRANSFERBESTIMMUNG_28', // 1b
                'KFZ_VERSICHERERWECHSEL_SELBES_FZG', // 3
                'KFZ_VERSICHERERWECHSEL_NEUES_FZG' // 4b
            ]);
        }

        function isRabattuebertragungVorversicherungAufDrittenErlaubt() {
            return (
                AngebotKfzService.isGevo(angebotVm.angebotModel.angebot, [
                    'KFZ_TRANSFERBESTIMMUNG_28', // 1b
                    'KFZ_NEUGESCHAEFT' // 1
                ])
                &&
                _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.sondereinstufungYD') !== true &&
                _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.sondereinstufungMoped') !== true &&
                !_.includes([
                    wagniskennziffern.ANHAENGER_WERKNAH_UND_PRIVATVERKEHR, // 501
                    wagniskennziffern.WOHNWAGENANHAENGER // 541
                ], wkz) &&
                (
                    (
                        _.includes([
                            wagniskennziffern.LANDWIRTSCHAFTLICHE_ZUGMASCHINEN_MIT_GRÜNEM_KENNZEICHEN, // 451
                            wagniskennziffern.LANDWIRTSCHAFTLICHE_ZUGMASCHINEN_MIT_SCHWARZEM_KENNZEICHEN // 452
                        ], wkz) &&
                        (
                            angebotVm.angebotModel.wurdeGeladen ||
                            angebotVm.angebotModel.wurdeKopiert
                        ) &&
                        _.get(angebotVm.angebotModel.angebotOriginal, 'rabattuebertragung.vorversicherungAufDritten') === true
                    ) || (
                    !_.includes([
                        wagniskennziffern.LANDWIRTSCHAFTLICHE_ZUGMASCHINEN_MIT_GRÜNEM_KENNZEICHEN, // 451
                        wagniskennziffern.LANDWIRTSCHAFTLICHE_ZUGMASCHINEN_MIT_SCHWARZEM_KENNZEICHEN // 452
                    ], wkz)
                    )
                )
            );
        }

        function isBlockArbeitgeberBerufErlaubt() {
            return (
                angebotVm.isPrivatPerson
            );
        }

        function isBlockFahrerkreisErlaubt() {
            return (
                vm.isJuengsterFahrerGeburtsdatumErlaubt() ||
                vm.isGeburtsdatumAntragstellerErlaubt() ||
                (vm.isJuengsterFahrerGeburtsdatumErlaubt() && _.get(angebotVm.angebotModel.formData, 'fahrzeugFahrerNurVn') === false) ||
                (vm.isJuengsterFahrerGeburtsdatumErlaubt() && _.get(angebotVm.angebotModel.formData, 'fahrzeugFahrerNurVn') === false)
            );
        }
    }
})();
